import React from 'react';

const FormSubmit = ({ label, testid, disabled }) => (
  <input
    type="submit"
    className="btn btn-primary"
    value={label}
    data-testid={testid}
    disabled={disabled}
  />
);

export default FormSubmit;
